const hidde_scrollbar = () => {
    // 隐藏页面滚动条
    let m = window.innerWidth - document.body.clientWidth // 滚动条的宽度
    document.documentElement.style.marginRight = m + 'px'
    document.documentElement.style.overflowY = 'hidden'
}

const show_scrollbar = () => {
    // 显示页面滚动条
    document.documentElement.style.marginRight = '0px'
    document.documentElement.style.overflowY = 'auto'
}

const preFetch = (list) => {
    // 空闲时，加载即将会用到的资源
    for (let i = 0, len = list.length; i < len; i++) {
        const link = document.createElement("link");
        link.rel = "prefetch";
        link.href = list[i];
        document.head.appendChild(link);
    }
}

const preload = (list) => {
    // 强制浏览器先请求资源
    for (let i = 0, len = list.length; i < len; i++) {
        const link = document.createElement("link");
        link.rel = "preload";
        link.as = list[i].as;
        link.href = list[i].url;
        if (list[i].as === "font") {
            // 请求字体时需要使用匿名的跨域模式
            link.crossOrigin = "";
        }
        document.head.appendChild(link);
    }
}

const isPC = () => {
    // 判断设备是否是pc
    let userAgentInfo = navigator.userAgent;
    let Agents = new Array(
        "Android",
        "iPhone",
        "SymbianOS",
        "Windows Phone",
        "iPad",
        "iPod"
    );
    let flag = true;
    for (let v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
            flag = false;
            break;
        }
    }
    return flag;
}

const clientType = () => {
    let u = navigator.userAgent;
    let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;   //判断是否是 android终端
    let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);     //判断是否是 iOS终端
    if (isAndroid) {
        return 'Android';
    } else if (isIOS) {
        return 'IOS';
    } else {
        return 'PC';
    }
}

export default {
    hidde_scrollbar,
    show_scrollbar,
    preFetch,
    preload,
    isPC,
    clientType
}